export enum PaymentStatus {
  Paid = 1,
  Unpaid,
  Moved,
}
